import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const TeamMembers = ({ 
  selectedEightD, 
  teamMembers, 
  showForm, 
  setShowForm,
  editingMember,
  teamMemberForm,
  onFormChange,
  onSave,
  onDelete,
  onEdit,
  onReset
}) => {
  const { t } = useLanguage();

  if (!selectedEightD) return null;

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 mb-6 border border-purple-100">
      <h2 className="text-xl font-bold text-gray-800 mb-4">
        D1 - {t('acciones.teamMembers.title')}
        <span className="ml-3 text-sm font-normal text-purple-600">
          ({selectedEightD.code})
        </span>
      </h2>

      {/* Botón para mostrar formulario */}
      {!showForm && !editingMember && (
        <div className="mb-4">
          <button
            onClick={() => setShowForm(true)}
            className="px-4 py-2 bg-purple-600 text-white font-bold rounded-lg hover:bg-purple-700"
          >
            + {t('acciones.teamMembers.add')}
          </button>
        </div>
      )}

      {/* Formulario */}
      {(showForm || editingMember) && (
        <div className="bg-purple-50 p-4 rounded-lg mb-4">
          <h3 className="font-semibold text-gray-800 mb-3">
            {editingMember ? t('acciones.teamMembers.edit') : t('acciones.teamMembers.add')}
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div>
              <label className="block text-sm font-semibold text-gray-800 mb-1">
                {t('acciones.teamMembers.name')} *
              </label>
              <input
                type="text"
                name="name"
                value={teamMemberForm.name}
                onChange={onFormChange}
                className="w-full rounded border border-gray-300 px-3 py-2 text-gray-900"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-800 mb-1">
                {t('acciones.teamMembers.role')} *
              </label>
              <input
                type="text"
                name="role"
                value={teamMemberForm.role}
                onChange={onFormChange}
                className="w-full rounded border border-gray-300 px-3 py-2 text-gray-900"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-800 mb-1">
                {t('acciones.teamMembers.email')}
              </label>
              <input
                type="email"
                name="email"
                value={teamMemberForm.email}
                onChange={onFormChange}
                className="w-full rounded border border-gray-300 px-3 py-2 text-gray-900"
              />
            </div>
          </div>

          <div className="flex gap-2">
            <button
              onClick={onSave}
              className="px-4 py-2 bg-purple-600 text-white font-bold rounded-lg hover:bg-purple-700"
            >
              {editingMember ? t('acciones.buttons.update') : t('acciones.buttons.add')}
            </button>
            <button
              onClick={onReset}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
            >
              {t('acciones.buttons.cancel')}
            </button>
          </div>
        </div>
      )}

      {/* Lista de miembros */}
      <div className="overflow-x-auto">
        <table className="w-full border border-gray-200 text-sm">
          <thead className="bg-purple-600 text-white">
            <tr>
              <th className="px-4 py-2 text-left font-bold">{t('acciones.teamMembers.name')}</th>
              <th className="px-4 py-2 text-left font-bold">{t('acciones.teamMembers.role')}</th>
              <th className="px-4 py-2 text-left font-bold">{t('acciones.teamMembers.email')}</th>
              <th className="px-4 py-2 text-center font-bold">{t('acciones.buttons.actions')}</th>
            </tr>
          </thead>
          <tbody>
            {teamMembers.length === 0 ? (
              <tr>
                <td colSpan="4" className="px-4 py-8 text-center text-gray-500">
                  {t('acciones.teamMembers.noMembers')}
                </td>
              </tr>
            ) : (
              teamMembers.map((member, index) => (
                <tr
                  key={member.id}
                  className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                >
                  <td className="px-4 py-2">{member.name}</td>
                  <td className="px-4 py-2">{member.role}</td>
                  <td className="px-4 py-2">{member.email || '-'}</td>
                  <td className="px-4 py-2 text-center">
                    <div className="flex justify-center gap-2">
                      <button
                        onClick={() => onEdit(member)}
                        className="px-3 py-1 bg-blue-50 text-blue-700 border border-blue-300 rounded-lg text-sm font-semibold hover:bg-blue-100"
                      >
                        {t('acciones.buttons.edit')}
                      </button>
                      <button
                        onClick={() => onDelete(member.id)}
                        className="px-3 py-1 bg-red-50 text-red-700 border border-red-300 rounded-lg text-sm font-semibold hover:bg-red-100"
                      >
                        {t('acciones.buttons.delete')}
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TeamMembers;
